import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const SubstitutionContainer = styled(Box)(() => ({
  display: 'flex',
}));